import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_SKILLCATEGORY,
  GET_SKILLCATEGORY_SUCCESS,
  ADD_SKILLCATEGORY,
  ADD_SKILLCATEGORY_SUCCESS,
  UPDATE_SKILLCATEGORY,
  UPDATE_SKILLCATEGORY_SUCCESS,
  DELETE_SKILLCATEGORY,
  DELETE_SKILLCATEGORY_SUCCESS,
  DELETE_SKILLCATEGORY_ERROR,
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getSkillCategoryApi() {
  // api for get designation.
  const response = api.dbSkillCategory().GetAllSkillCategories();
  return response;
}
function addSkillCategoryApi(formData) {
  // api for add designation.
 const response= api.dbSkillCategory().AddEditSkillCategories(formData);
 return response;
}

function updateSkillCategoryApi(formData) {
  // api for update designation.
  api.dbSkillCategory().AddEditSkillCategories(formData);
}
function delSkillCategoryApi(delId) {
  // api for delete designation.
  const response = api.dbSkillCategory().DeleteSkillCategories(delId);
  return response;
}

// get designation list.
export function* handleGetSkillCategory() {
  try {
    const response = yield call(getSkillCategoryApi);
    yield put({ type: GET_SKILLCATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
export function* handleAddSkillCategory({ payload }) {
  try {
   const response= yield call(addSkillCategoryApi, payload);
   payload={...payload,"skillCategoryId":response.data}
    yield put({ type: ADD_SKILLCATEGORY_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

export function* handleUpdateSkillCategory({ payload }) {
  try {
    let formData = payload;
    yield call(updateSkillCategoryApi, formData);
    yield put({ type: UPDATE_SKILLCATEGORY_SUCCESS, payload: formData });
  } catch (error) {
     
  }
}

export function* handleDelSkillCategory({ payload }) {
  try {
    yield call(delSkillCategoryApi, payload);
    yield put({ type: DELETE_SKILLCATEGORY_SUCCESS, payload: payload });
  } catch (error) {
    yield put({ type: DELETE_SKILLCATEGORY_ERROR});
     
  }
}

// watach function.
export function* skillCategoryWatchFun() {
  yield takeLatest(GET_SKILLCATEGORY, handleGetSkillCategory);
  yield takeLatest(ADD_SKILLCATEGORY, handleAddSkillCategory);  
  yield takeLatest(UPDATE_SKILLCATEGORY, handleUpdateSkillCategory);  
  yield takeLatest(DELETE_SKILLCATEGORY, handleDelSkillCategory);
}
